import React from "react";
import {useTranslation} from "react-i18next";
import SpaceBetween from "@awsui/components-react/space-between";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import Tabs from "@awsui/components-react/tabs";
import PointsTable from "pages/about/components/PointsTable";


const stagePositionPoints: number[] = [125, 80, 70, 60, 50, 40, 30, 25, 20, 17, 15, 13, 11, 9, 7, 5, 4, 3, 2, 1];
const stageGCPoints: number[] = [30, 15, 10, 5, 2, 1];
const stageTTTPoints: number[] = [50, 25, 5];

const finalGCPoints: number[] = [500, 400, 325, 225, 190, 160, 135, 120, 105, 90, 75, 65, 55, 45, 35, 30, 25, 20, 15, 10, 7, 5, 3, 2, 1];
const finalMountainPoints: number[] = [100];
const finalGreenPoints: number[] = [100];
const finalYoungPoints: number[] = [100];
const finalFirstBasquePoints: number[] = [100];
const finalTeamPoints: number[] = [50];

const questionsPoints: number[] = [50];

const AboutPage: React.FC = () => {
    const {t} = useTranslation("about");
    return (
        <SpaceBetween size={"l"}>
            <NavigationBar />
            <Container
                variant={"default"}
                header={
                    <Header variant={"h2"}>
                        {t("title")}
                    </Header>
                }
            >
                <Tabs
                    tabs={[
                        {
                            label: t("tabs.pointsPerStage"),
                            id: "pointsPerStageTab",
                            content:
                                <SpaceBetween size="m" direction="horizontal">
                                    <PointsTable
                                        title={t("tables.stagePosition")}
                                        points={stagePositionPoints}
                                    />
                                    <PointsTable
                                        title={t("tables.stageGc")}
                                        points={stageGCPoints}
                                    />
                                    <PointsTable
                                        title={t("tables.stageTtt")}
                                        points={stageTTTPoints}
                                    />
                                </SpaceBetween>
                        },
                        {
                            label: t("tabs.pointsPerGc"),
                            id: "pointsPerGCTab",
                            content:
                                <SpaceBetween size="m" direction="horizontal">
                                    <PointsTable
                                        title={t("tables.finalGc")}
                                        points={finalGCPoints}
                                    />
                                    <PointsTable
                                        title={t("tables.mountain")}
                                        points={finalMountainPoints}
                                    />
                                    <PointsTable
                                        title={t("tables.regularity")}
                                        points={finalGreenPoints}
                                    />
                                    <PointsTable
                                        title={t("tables.young")}
                                        points={finalYoungPoints}
                                    />
                                    <PointsTable
                                        title={t("tables.firstBasque")}
                                        points={finalFirstBasquePoints}
                                    />
                                    <PointsTable
                                        title={t("tables.teamClassification")}
                                        points={finalTeamPoints}
                                    />
                                    <PointsTable
                                        title={t("tables.questions")}
                                        points={questionsPoints}
                                    />
                                </SpaceBetween>
                        }
                    ]}
                />
            </Container>
        </SpaceBetween>
    );
};

export default AboutPage;
